import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {ToastMessageService} from "../../services/toast-message.service";

@Component({
	selector: 'fb-product-share-icon',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './product-share-icon.component.html',
	styleUrls: ['./product-share-icon.component.scss']
})
export class ProductShareIconComponent {

	@Input() public productName: string = '';
	@Input() public productDescription: string = '';

	constructor(
		private _toast: ToastMessageService
	) {
	}

	public async share(): Promise<void> {
		if (navigator.share) {
			try {
				await navigator.share({
					title: this.productName,
					text: this.productDescription,
					url: window.location.href,
				});
			} catch (error) {
				// this.copyLink();
			}
		} else {
			this.copyLink();
		}
	}

	public copyLink(): void {
		navigator.clipboard.writeText(window.location.href).then(() => {
			this._toast.info('Product Link copied to clipboard!', 'You can paste the link anywhere to share');
		});
	}
}
